import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Checkbox } from '@verclam/ui-kit';

const tileStyle = css`
	padding: 0.75rem 0.875rem;
	border-radius: ${theme.radii.small};
	background-color: ${theme.colors.surfaceMuted};
`;

type Props = {
	readonly name: string;
	readonly label: string;
	readonly checked: boolean;
	readonly disabled?: boolean;
	readonly onChange: (checked: boolean) => void;
};

/** A checkbox set on a recessed tile, as every yes/no choice of the group screens. */
const CheckboxTile: React.FC<Props> = ({ name, label, checked, disabled, onChange }) => {
	return (
		<div css={tileStyle}>
			<Checkbox name={name} label={label} checked={checked} disabled={disabled} onChange={onChange} />
		</div>
	);
};

export default CheckboxTile;
